module.exports = __webpack_public_path__ + "static/media/roof-7.ec046764.jpg";